module.exports = __webpack_public_path__ + "img/logopyv-dark.868f0e81.svg";